import { createAction, props } from '@ngrx/store';
import { ITransactionResponse } from '../models/transactions.model';

export const loadTransactionsFailures = createAction('[TransactionsFailure] Load TransactionsFailures', props<{ customerId: string }>());

export const loadTransactionsFailuresSuccess = createAction(
  '[TransactionsFailure] Load TransactionsFailures Success',
  props<{ response: ITransactionResponse[] }>()
);

export const loadTransactionsFailuresFailure = createAction(
  '[TransactionsFailure] Load TransactionsFailures Failure',
  props<{ error: Error | any }>()
);
